// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Roboto', 'Roboto Fallback'","fontWeight":400,"fontStyle":"normal"},"className":"__className_10f679","variable":"__variable_10f679"};